<app-header [title]="title"></app-header>
<main class="start-project">
  <article class="containero">
    <div class="left">
      <div class="leaning">
        <a routerLink="/choose-project">
          <strong><span>Wybierz<br> gotowy <br>projekt domu</span></strong>
          <p class="icon"><fa-icon [icon]="faHandPointer"></fa-icon></p>
        </a>
      </div>
    </div>
    <div class="right">
      <div class="leaning" (click)="fileUpload.click()" appDragDrop (onFileDropped)="loadFile($event)">
        <label   style="cursor: pointer;">
          <strong><span>PRZECIĄGNIJ TUTAJ <br>LUB ZAŁADUJ ZDJĘCIE<br> SWOJEGO DOMU Z DYSKU<br></span></strong>
          <p class="icon"><fa-icon [icon]="faFileUpload"></fa-icon></p>
        </label>
      </div>
    </div>
    <div class="leaning loading" id="loading">
      <div class="content">
        <h3>WCZYTYWANIE ZDJĘCIA!</h3>
        <p><img src="assets/ikony/aplikacja-ikony-21.png" alt=""></p>
      </div>
    </div>
  </article>
</main>
<input type="file" hidden accept="image/*" name="image" id="file" (change)="loadFile($event.target.files)" #fileUpload>
